import { cn } from "@workspace/ui/lib/utils";
import { useRouter } from "next/router";
import type * as React from "react";
import { DashboardHeader } from "@/components/dashboard-header";
import { DashboardSidebar } from "@/components/dashboard-sidebar";

type SiteLayoutProps = {
  children: React.ReactNode;
};

// react-doctor-disable-next-line react-doctor/only-export-components -- Pages Router layout module: the component is co-located with its required getLayout export.
function SiteLayout({ children }: SiteLayoutProps) {
  const router = useRouter();

  if (!router.isReady) {
    return null;
  }
  const isConversationsPage = router.pathname.startsWith("/conversations");
  const isConversationsIdPage = router.pathname === "/conversations/[id]";
  const ownsViewport =
    isConversationsPage || router.pathname === "/job-listings";

  return (
    <div className="min-h-svh bg-background">
      <DashboardSidebar />
      <main
        className={cn(
          "flex min-h-svh max-w-full flex-col overflow-hidden md:ml-[70px]",
          ownsViewport && "h-svh"
        )}
        id="main-content"
      >
        <DashboardHeader hideOnMobile={isConversationsIdPage} />
        <div className="flex min-h-0 flex-1 flex-col">{children}</div>
      </main>
    </div>
  );
}

export const getLayout = (page: React.ReactElement) => (
  <SiteLayout>{page}</SiteLayout>
);
